<template>
  <div class="container">
    <h3 class="green subtitle">
      {{ $translate('subtitle_form_model_details') }}
    </h3>
    <hr />
    <b-field horizontal :label="$translate('drilled_fodera') | capitalize">
      <b-switch v-model="mod.hasDrilledFodera" />
    </b-field>
    <b-field horizontal :label="$translate('allacciatura_velcro') | capitalize">
      <b-switch v-model="mod.hasVelcro" />
    </b-field>
    <b-field horizontal :label="$translate('forte_alto') | capitalize">
      <b-switch v-model="mod.hasForteAlto" />
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'ModDetails',
  props: ['mod'],
}
</script>
<style scoped>
.container >>> .column select {
  min-width: 200px;
}
</style>
